'use client';
import React, { useState, useEffect, useRef } from 'react';
import styles from './SearchBar.module.css';

export default function SearchBar({ allCourses }) {
    const [query, setQuery] = useState('');
    const [suggestions, setSuggestions] = useState([]);
    const [courses, setCourses] = useState([]);
    const containerRef = useRef();

    // Fetch courses from API if not provided as prop
    useEffect(() => {
        if (allCourses && allCourses.length > 0) {
            setCourses(allCourses);
        } else {
            // Fallback to API fetch if courses not passed as prop
            fetch('/api/catalog')
                .then(res => res.json())
                .then(data => {
                    if (data && Array.isArray(data)) {
                        setCourses(data);
                    }
                })
                .catch(err => console.error('Failed to fetch courses:', err));
        }
    }, [allCourses]);

    // Update suggestion list as the user types
    useEffect(() => {
        const q = query.trim().toLowerCase();
        if (!q) {
            setSuggestions([]);
        } else {
            setSuggestions(
                courses
                    .filter((c) => c.name.toLowerCase().includes(q))
                    .slice(0, 8) // limit to 8 entries
            );
        }
    }, [query, courses]);

    // Hide dropdown when clicking outside
    useEffect(() => {
        const onClickOutside = (e) => {
            if (containerRef.current && !containerRef.current.contains(e.target)) {
                setSuggestions([]);
            }
        };
        document.addEventListener('click', onClickOutside);
        return () => document.removeEventListener('click', onClickOutside);
    }, []);

    return (
        <div className={styles.container} ref={containerRef}>
            <input
                type="text"
                className={styles.input}
                placeholder="Search classes…"
                value={query}
                onChange={(e) => setQuery(e.target.value)}
            />

            {suggestions.length > 0 && (
                <ul className={styles.dropdown}>
                    {suggestions.map((c) => (
                        <li
                            key={c.id}
                            className={styles.item}
                            onClick={() => (window.location.href = `/classes/${c.id}`)}
                        >
                            {c.name}
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
}